import React from 'react';
import {useTranslation} from 'react-i18next';
import {WhiteButton} from '@styled';
import AddEntityModal from './AddEntityModal';

const AddEntityController = ({toggleMenuSidebar}) => {
  const [t] = useTranslation();
  const [showEntityModal, toggleEntityModal] = React.useState(false);
  const handleAddEntity = () => {
    toggleEntityModal(true);
    toggleMenuSidebar();
  };

  return (
    <>
      <WhiteButton
        className="btn-block mb-1 rounded-0 border-left-0 border-right-0"
        onClick={handleAddEntity}
      >
        {t('reporter.entity.addEntity')}
      </WhiteButton>
      <AddEntityModal show={showEntityModal} toggleModal={toggleEntityModal} />
    </>
  );
};

export default AddEntityController;
